import React from "react";
import Box from "@mui/material/Box";

// Custom.
import Content from "containers/Layout/Content";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { ErrorBox } from "@vocollege/components";

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error: any) {
    return {
      hasError: true,
      error: error.message || error,
    };
  }
  render() {
    if (this.state.hasError) {
      return (
        <Content>
          <Box sx={{ margin: "0 auto", maxWidth: 800 }}>
            <ErrorBox
              severity="error"
              title={I18n.get.misc.error}
              content={JSON.stringify(this.state.error)}
              buttonTitle={I18n.get.actions.backToHome}
              buttonPath="/"
            />
          </Box>
        </Content>
      );
    }
    return <>{this.props.children}</>;
  }
}
export default ErrorBoundary;
